module.exports = __webpack_public_path__ + "img/img3.cd726416.png";